import React from "react";
import { Routes, Route } from "react-router-dom";
import WialonMainPage from "../pages/WialonMainPage";
import WialonUsersPage from "../pages/WialonUsersPage";
import WialonUnidadesPage from "../pages/WialonUnidadesPage";
import WialonGruposPage from "../pages/WialonGruposPage";

const WialonRoutes = () => {
  return (
    <Routes>
      <Route index element={<WialonMainPage />} />
      <Route path="usuarios" element={<WialonUsersPage />} />
      <Route path="vehiculos" element={<WialonUnidadesPage />} />
      <Route path="grupos" element={<WialonGruposPage />} />
      <Route path="*" element={<WialonMainPage />} />
    </Routes>
  );
};

export default WialonRoutes;
